import React from 'react'
import classnames from 'classnames'

import './Card.scss'

const Card = ({ className, children }) => {
  const c = classnames('frontend_cards-layout_card', className)
  return (
    <article className={c}>
      {children}
    </article>
  )
}

export default Card
